/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createLayout,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { lazyForPaint, lazyAfterPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type ResourcesCleanup from './ui/resources-invalidate/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanResourcesInvalidate: LazyComponent<() => null> = lazyForPaint<
	typeof ResourcesCleanup
>(
	() =>
		import(
			/* webpackChunkName: "async-plan-resources-invalidate" */ './ui/resources-invalidate/index.tsx'
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const Onboarding: LazyComponent<() => React.JSX.Element | null> = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-plan-onboarding" */ './ui/onboarding/index.tsx'),
	{ ssr: false },
);
Onboarding.displayName = 'Onboarding';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const RightSidebars: LazyComponent<() => React.JSX.Element | null> = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-plan-right-sidebars" */ './ui/right-sidebars/index.tsx'),
	{ ssr: false },
);
RightSidebars.displayName = 'RightSidebars';

export const planLayout: Layout = createLayout({
	rightSidebars: [RightSidebars],
	globalComponents: [LazyPlanResourcesInvalidate, Onboarding],
});

export const planLayoutWithoutInvalidation: Layout = createLayout({
	rightSidebars: [RightSidebars],
	globalComponents: [Onboarding],
});
